import { InvoiceStatus, DealStatus, InvoiceTableRowStatus, DealDisplayStatus } from './sharedTypes';

export const billStatusToColor = {
    [InvoiceStatus.Created]: 'text',
    [InvoiceStatus.Initialized]: 'info',
    [InvoiceStatus.Archived]: 'error',
    [DealStatus.Submitted]: 'info',
    [DealStatus.Current]: 'success',
    [DealStatus.Late]: 'warning',
    [DealStatus['Grace Period']]: 'error',
    [DealStatus['Early Completed']]: 'info',
    [DealStatus.Completed]: 'info',
    [DealStatus.Default]: 'error',
};

export const invoiceOrDealStatusToLabel = {
    [InvoiceStatus.Created]: InvoiceTableRowStatus.Ready,
    [InvoiceStatus.Initialized]: InvoiceTableRowStatus.Initialized,
    [InvoiceStatus.Archived]: InvoiceTableRowStatus.Archived,
    [DealStatus.Submitted]: InvoiceTableRowStatus.UnderReview,
    [DealStatus.Current]: InvoiceTableRowStatus.Active,
    [DealStatus.Late]: InvoiceTableRowStatus.Late,
    [DealStatus['Grace Period']]: InvoiceTableRowStatus.GracePeriod,
    [DealStatus['Early Completed']]: InvoiceTableRowStatus.PaidOff,
    [DealStatus.Completed]: InvoiceTableRowStatus.PaidOff,
    [DealStatus.Default]: InvoiceTableRowStatus.Defaulted,
    [DealDisplayStatus.Rejected]: InvoiceTableRowStatus.Rejected,
};

export enum StatusColors {
    'MeadowGreen' = '#21B448',
    'KumeraYellow' = '#8A6224',
    'ButtercupYellow' = '#F3A621',
    'HavelockBlue' = '#5090DC',
    'MeteorOrange' = '#CC6F10',
    'BurntSienna' = '#EF5452',
    'ShuttleGray' = '#5D6676',
    'MexicanRed' = '#A82529',
}

export const invoiceTableRowStatusToColor = {
    [InvoiceTableRowStatus.Ready]: StatusColors.MeadowGreen,
    [InvoiceTableRowStatus.Archived]: StatusColors.KumeraYellow,
    [InvoiceTableRowStatus.UnderReview]: StatusColors.ButtercupYellow,
    [InvoiceTableRowStatus.Active]: StatusColors.HavelockBlue,
    [InvoiceTableRowStatus.GracePeriod]: StatusColors.MeteorOrange,
    [InvoiceTableRowStatus.Late]: StatusColors.BurntSienna,
    [InvoiceTableRowStatus.PaidOff]: StatusColors.ShuttleGray,
    [InvoiceTableRowStatus.Defaulted]: StatusColors.MexicanRed,
    [InvoiceTableRowStatus.Rejected]: StatusColors.MexicanRed,
};
